module.exports = __webpack_public_path__ + "img/glive.e240a2f.webp";